import React, { createContext, useContext } from 'react'
import withStyles from '@mui/styles/withStyles'
import { themeStyles } from 'themes'

interface IContextProps {
    classes: any
}
export const Context = createContext({} as IContextProps)

interface IProps {
    classes: any
}

const TableFrame: React.FC<IProps> = ({ classes, children }) => {
    return (
        <div className={classes.tableCard}>
            <div className={classes.tableCardContent}>
                <Context.Provider value={{ classes }}>{children}</Context.Provider>
            </div>
        </div>
    )
}

export default withStyles(themeStyles.useTableStyles)(TableFrame)
